import fontControlInit from "../components/fontSizeControl";
import onceModalInit from "../components/onceModal";
import tawkControllerInit from "../components/tawkChatController";
import termsInit from "./components/acceptTermsModal";
import { initializeTrayIcon, updateTrayIcon } from "./components/mailbox";
import doPostRequest from "../components/postForm";

function processToSearcherEvent(this: HTMLButtonElement) {
  let url = $(this).data("url");
  if (url.startsWith("/")) {
    url = url.substr(1);
  }
  const productType = $(this).data("product-type");

  doPostRequest(url, {"product": productType});
}
const TO_HOME_POST_FORM_LINKS_SELECTOR =  ".ims-searcher-post-form";
const initToHomePostFormEvents = () => {
  $(TO_HOME_POST_FORM_LINKS_SELECTOR).click(processToSearcherEvent);
}

/**
 * Script que se incluye en el template de forma que está en todas las páginas.
 */
$(() => {
  /* Escala de la fuente */
  fontControlInit("ims-a-decrease-text", "ims-a-enlarge-text");

  /* Icono bandeja de entrada. */
  initializeTrayIcon();

  /* Modal de bienvenida. Si existe, se muestra la primera vez por visita. */
  onceModalInit();

  /* Chat */
  tawkControllerInit();

  /* Modal de condiciones */
  termsInit();

  /* Inicializar eventos de elementos de páginas con enlace a ejecutar como post, para ir a la paágina de reserva. */
  initToHomePostFormEvents();

});

/* Métodos publicados para acceder desde js y html.
 * Actualmente sirve de interacción con la parte vieja. */
// TODO: Definir interfaz
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).ImsTemplate = {
  updateTrayIcon: (unread: number) => {
    /* Esto está publicado y se puede acceder desde js viejo y html. Hay que
     * validar que lo que entra está bien. */
    if (typeof unread === "number") {
      updateTrayIcon(unread);
    }
  },
};
